import React from 'react';

import { useIntl } from 'react-intl';
import maintenanceIcon from '../../assets/image/maintenance/maintenance.svg';

const SystemMaintenance = () => {
  const translate = useIntl();

  return (
    <div className="maintenance">
      <h1 className="maintenance__title">
        {translate.formatMessage({ id: 'maintenance.header' })}
      </h1>
      <img src={maintenanceIcon} alt="SystemMaintenance" />
      <h2 className="maintenance__subTitle">
        {translate.formatMessage({ id: 'maintenance.exclamation' })}
      </h2>
      {/* <p className="maintenance__description"> */}
      {/*   {translate.formatMessage({ id: 'maintenance.description' })} */}
      {/* </p> */}
      <p className="maintenance__patience">
        {translate.formatMessage({ id: 'maintenance.patience' })}
      </p>
      <p className="maintenance__team">
        {translate.formatMessage({ id: 'maintenance.team' })}
      </p>
    </div>
  );
};

export default SystemMaintenance;
